/**
 * Checks if the locale has a date format from [MicroLibraryAppDetailsUI](https://dev.azure.com/orcha/MicroLibraryTemplate/_git/MicroLibraryAppDetailsUI)
 * @param locale - The locale to check.
 * @returns True if the locale has a date format, false otherwise.
 */

export const localeHasDateFormat = (locale?: string) => {
  return locale === 'en-US' || locale === 'en-GB';
};
